export default async function wait(time = 0): Promise<void> {
	return new Promise((resolve) => {
		setTimeout(resolve, time);
	});
}
